import { strValOrUndef } from "@paroi/data-formatters-lib";

const stagingAPIUrl = strValOrUndef(import.meta.env.VITE_STAGING_API_URL, {
  varName: "VITE_STAGING_API_URL",
});
const stagingAPIToken = strValOrUndef(import.meta.env.VITE_STAGING_API_TOKEN, {
  varName: "VITE_STAGING_API_TOKEN",
});
const prodAPIUrl = strValOrUndef(import.meta.env.VITE_PROD_API_URL, {
  varName: "VITE_PROD_API_URL",
});
if (process.env.NODE_ENV === "development" && (!stagingAPIUrl || !stagingAPIToken)) {
  throw new Error("VITE_API_BASE_URL or VITE_API_TOKEN env variable not defined");
}
export const STAGING_API_URL = stagingAPIUrl;
export const STAGING_API_TOKEN = stagingAPIToken;
export const PROD_API_URL = prodAPIUrl;
